import { render, staticRenderFns } from "./marquee-yuri.vue?vue&type=template&id=78146004&scoped=true&"
import script from "./marquee-yuri.vue?vue&type=script&lang=js&"
export * from "./marquee-yuri.vue?vue&type=script&lang=js&"
import style0 from "./marquee-yuri.vue?vue&type=style&index=0&id=78146004&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78146004",
  null
  
)

export default component.exports